import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialog } from "@angular/material/dialog";
import { MatFormField, MatLabel,MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatMenu, MatMenuItem,MatMenuTrigger } from '@angular/material/menu';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow,MatRowDef, MatTable } from '@angular/material/table';
import { Router, RouterLink } from "@angular/router";

import { AdminComponentBase } from 'app/layout/content';
import { PageSimpleContentComponent } from 'app/layout/content/page-simple-content.component';
import { AuthorizationContext, AuthorizationService } from 'app/shared/authentication';
import { ErrorComponent } from 'app/shared/components/error.component';
import { GlobalPermission, StockPhotoSourceConfig } from 'app/shared/graph';
import { CopyToClipboardComponent } from 'app/shared/utilities/copy-to-clipboard.component';

import {
    AddStockPhotoSourceDialogComponent,
    AddStockPhotoSourceDialogResult
} from "./add-stock-photo-source-dialog.component";
import {
    RelatedStoresStockPhotoSourceDialogComponent,
    RelatedStoresStockPhotoSourceDialogData
} from "./related-store-stock-photo-source-dialog.component";
import { StockPhotoSourcesService } from './stock-photo-sources.service';

@Component({
    selector: 'admin-stock-photo-sources-page',
    templateUrl: './stock-photo-sources-page.component.html',
    styleUrls: ['./stock-photo-sources-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageSimpleContentComponent, MatFormField, MatIcon, MatPrefix, MatLabel, MatInput, FormsModule, MatButton, ErrorComponent, MatTable, MatColumnDef, MatHeaderCell, MatCell, RouterLink, CopyToClipboardComponent, MatIconButton, MatMenuTrigger, MatMenu, MatMenuItem, MatHeaderRow, MatRow, MatHeaderCellDef, MatCellDef, MatHeaderRowDef, MatRowDef]
})
export class StockPhotoSourcesPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly authorizationService = inject(AuthorizationService);
    private readonly stockPhotoSourcesService = inject(StockPhotoSourcesService);
    private readonly dialog = inject(MatDialog);
    private readonly router = inject(Router);


    @ViewChild('stockPhotoSourcesTable', { static: false })
    stockPhotoSourcesTable: MatTable<StockPhotoSourceConfig>;
    stockPhotoSources: StockPhotoSourceConfig[] = [];
    displayedStockPhotoSources: StockPhotoSourceConfig[] = [];
    displayedColumns: string[] = [
        'id',
        'photosEndpointUrl',
        'visibility',
        'enabled',
        'actions'
    ];
    filter: {
        name: string;
    } = {
        name: ''
    };

    private authorizationContext: AuthorizationContext;

    ngOnInit(): void {
        this.registerSubscription(this.authorizationService.authorizationContext().subscribe(authorizationContext => {
            this.authorizationContext = authorizationContext;
        }));

        this.subscribeWithGenericLoadingErrorHandling(this.stockPhotoSourcesService.list(), (stockPhotoSources) => {
            this.stockPhotoSources = stockPhotoSources;
            this.updateDisplayedStockPhotoSources();
        });
    }

    ngOnDestroy(): void {
        this.unsubscribeSubscriptions();
    }

    updateFilter() {
        this.updateDisplayedStockPhotoSources();
    }

    private updateDisplayedStockPhotoSources() {
        this.displayedStockPhotoSources = this.stockPhotoSources
            .filter(s => this.isStockPhotoSourcesVisible(s))
            .sort((a, b) => a.id.localeCompare(b.id));
        this.stockPhotoSourcesTable.renderRows();
    }


    private isStockPhotoSourcesVisible(f: StockPhotoSourceConfig) {
        if (this.filter.name) {
            if (!f.id.toLowerCase().includes(this.filter.name.toLowerCase())) {
                return false;
            }
        }
        return true;
    }

    stockPhotoSourceId(i: number, stockPhotoSourceConfig: StockPhotoSourceConfig) {
        return stockPhotoSourceConfig.id;
    }

    addStockPhotoSource() {
        this.dialog.open<AddStockPhotoSourceDialogComponent, void, AddStockPhotoSourceDialogResult>(AddStockPhotoSourceDialogComponent).afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
            this.subscribeWithGenericSavingErrorHandling(this.stockPhotoSourcesService.createStockPhotoSource({
                id: result.id,
                label: result.label,
                visible: true,
                photosEndpoint: {
                    url: ''
                }
            }), () => {
                this.router.navigate(['/stock-photo-sources', result.id]);
            });
        });
    }

    showRelatedStores(stockPhotoSourceId: string) {
        this.dialog.open<RelatedStoresStockPhotoSourceDialogComponent, RelatedStoresStockPhotoSourceDialogData, void>(
            RelatedStoresStockPhotoSourceDialogComponent,
            {
                data: {
                    stockPhotoSourceId: stockPhotoSourceId
                }
            }).afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
        });
    }

    canManageStockPhotoSource(): boolean {
        return this.authorizationContext.hasGlobalPermissions(GlobalPermission.ManageStockPhotoSources);
    }


    $stockPhotoSource(source: any): StockPhotoSourceConfig {
        return source as StockPhotoSourceConfig;
    }
}
